import React from 'react';
import { Typography, Box, Stack, Chip, Paper } from '@mui/material';
import profile from '../profileData';

const Teaching = () => (
  <Box id="teaching" sx={{ py: { xs: 3, md: 5 }, px: { xs: 1, md: 0 }, maxWidth: { xs: '100%', md: 1200 }, mx: 'auto' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <Box sx={{ width: 4, height: 32, bgcolor: 'primary.main', mr: 2, borderRadius: 2 }} />
      <Typography variant="h4" fontWeight={700} sx={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: 1, fontSize: { xs: 24, md: 32 } }}>
        Teaching Experience
      </Typography>
    </Box>
    <Stack spacing={3} mt={2}>
      {/* Instructor Section */}
      {profile.teaching.instructor.map((exp, idx) => (
        <Paper 
          key={idx} 
          elevation={1}
            sx={{ 
            p: 2.5, 
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
              transform: 'translateY(-4px)',
              borderColor: 'primary.main',
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
            <Typography variant="h6" fontWeight={600} sx={{ fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 18, md: 20 } }}>
              Instructor
            </Typography>
            <Typography variant="h6" sx={{ fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 18, md: 20 }, color: 'text.secondary' }}>
              , {exp.organization}
            </Typography>
          </Box>
          <Box sx={{ mb: 1 }}>
            <Chip label={exp.period} color="primary" size="small" sx={{ fontWeight: 500, fontSize: { xs: 14, md: 16 } }} />
          </Box>
          <Stack spacing={1}>
            {exp.courses.map((course, courseIdx) => (
              <Box key={courseIdx}>
                <Typography variant="subtitle1" sx={{ fontSize: { xs: 16, md: 18 } }}>
                  {course.title}
                </Typography>
                {course.location && (
                  <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: { xs: 14, md: 16 }, fontStyle: 'italic' }}>
                    {course.location}
                  </Typography>
                )}
              </Box>
            ))}
          </Stack>
        </Paper>
      ))}
    </Stack>
  </Box>
);

export default Teaching; 